var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMailLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3C2.51367 3 1.5 4.01367 1.5 5.25V17.25C1.5 18.4863 2.51367 19.5 3.75 19.5H20.25C21.4863 19.5 22.5 18.4863 22.5 17.25V5.25C22.5 4.01367 21.4863 3 20.25 3H3.75ZM3.75 4.5H20.25C20.3027 4.5 20.3438 4.51758 20.3906 4.5293L12 10.3359L3.60938 4.5293C3.65625 4.51758 3.69727 4.5 3.75 4.5ZM3 5.92969L12 12.1641L21 5.92969V17.25C21 17.6719 20.6719 18 20.25 18H3.75C3.32812 18 3 17.6719 3 17.25V5.92969Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMailLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mail-logo.d2b1c2e8a565680b9181ca17901d8ea6.svg";